// extracted by mini-css-extract-plugin
export var underlinedLink = "_tg-0";